var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPharmaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9255 3.70407C16.9454 2.79358 15.7948 2.08594 14.5401 1.62186C13.2854 1.15779 11.9512 0.946453 10.6145 1.00002C9.32925 0.947277 8.04763 1.17021 6.8557 1.6539C5.66377 2.13758 4.58916 2.87078 3.70411 3.80423C1.88249 5.75434 0.909868 8.34805 1.00006 11.0151C0.946292 12.3216 1.15821 13.6254 1.623 14.8477C2.0878 16.0699 2.79578 17.1851 3.70411 18.1258C5.67272 19.9288 8.24542 20.929 10.915 20.929C13.5845 20.929 16.1572 19.9288 18.1258 18.1258C19.0534 17.1165 19.7704 15.9323 20.2347 14.6426C20.699 13.3528 20.9014 11.9834 20.8299 10.6145C20.8615 9.32279 20.619 8.03912 20.1184 6.84799C19.6177 5.65686 18.8704 4.58534 17.9255 3.70407Z",
    fill: "#3E9F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6235 10.8148C16.6114 11.4868 16.5445 12.1567 16.4232 12.8178H12.8178V16.7237C11.6008 17.024 10.3291 17.024 9.11217 16.7237V12.8178H5.40661C5.28496 12.2243 5.2179 11.6208 5.2063 11.0151C5.21816 10.3762 5.28518 9.73954 5.40661 9.1122H9.01205V5.20633C9.57172 5.08445 10.1419 5.01739 10.7146 5.00604C11.4262 5.00751 12.1342 5.10863 12.8178 5.30648V9.1122H16.4232C16.5392 9.67283 16.6062 10.2425 16.6235 10.8148Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaIcon);
export default __webpack_public_path__ + "static/media/pharma-icon.ffe4bc79aaab884c9bc51592286c4eed.svg";
export { ForwardRef as ReactComponent };